import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SaisieService } from 'src/app/saisie/saisie.service';
import { FormulaireService } from '../../../formulaire.service';
import { ModeRenduService } from '../../../mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-lieux-bav',
  templateUrl: './lieux-bav.component.html',
  styleUrls: ['./lieux-bav.component.css']
})
export class LieuxBavComponent implements OnInit, OnDestroy {
  public rootForm: UntypedFormGroup;
  step: number = 0;
  @Input()
  erreursMap: Map<string, string>;

  private subTab: Subscription[] = [];
  
  private subLieuxBav: Subscription;
  private valeurTableauA4c_1: number[] = [];
  private valeurTableauA4c_2: number[] = [];
  private valeurTableauA4c_3: number[] = [];

  constructor(
    private formulaireService: FormulaireService,
    public modeRenduService: ModeRenduService,
    public saisieService: SaisieService
  ) {
    this.rootForm = this.formulaireService.getRootForm();
    if (! this.listeBav) {
      (this.rootForm.get('dg') as UntypedFormGroup).setControl('listeBav', new UntypedFormArray([]));
    }
    if (! this.lieuxBav) {
      (this.rootForm.get('moyens') as UntypedFormGroup).setControl('lieuxBav', new UntypedFormArray([]));
    }
   }

  ngOnInit(): void {
    setTimeout(() => {
      // Calcul des totaux lieux Bav
        // On maj la boucle lieuxBav avec celle de Dg Bav
        this.subLieuxBav = this.listeBav.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {

          this.rootForm.get('moyens').get('aaLieuBavNb').setValue(this.rootForm.get('dg').get('xxBavNb').value);

          if (valeur instanceof Array) {

            if (this.subTab.length !== 0){
              this.subTab.forEach(element => element.unsubscribe());
            }

            this.valeurTableauA4c_1 = [];
            this.valeurTableauA4c_2 = [];
            this.valeurTableauA4c_3 = [];
            
            valeur.forEach((listeBav, index) => {
              // Maj de this.lieuxTj
              this.lieuxBav.controls[index].get('aaLieuBavRang').setValue(listeBav.xxBavRang);
              this.lieuxBav.controls[index].get('aaLieuBavIelst').setValue(listeBav.xxBavIelst);
              
              //Calcul totaux auto A4c
              this.calculAutoTotauxA4c(index, this.valeurTableauA4c_1, 'aaLieuBavNbPerm', 'aaLieuBavNbPermTot');      
              this.calculAutoTotauxA4c(index, this.valeurTableauA4c_2, 'aaLieuBavNbPermEtp', 'aaLieuBavNbPermEtpTot');      
              this.calculAutoTotauxA4c(index, this.valeurTableauA4c_3, 'aaLieuBavNbVict', 'aaLieuBavNbVictTot');   
            });
          }
        });
      this.listeBav.updateValueAndValidity();

      //Controles bloquants
      for (let index = 0; index < this.lieuxBav.length; index++) {
        this.saisieService.ajoutValidateurCroiseLieuxBav(this.lieuxBav, index);
        this.lieuxBav.controls[index].updateValueAndValidity();
      }  
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.subLieuxBav) {
      this.subLieuxBav.unsubscribe();
    }
    this.subTab.forEach(sub => { sub.unsubscribe(); });
  }

  get lieuxBav() {
    return this.rootForm.get('moyens').get('lieuxBav') as UntypedFormArray;
  }

  get listeBav() {
    return this.rootForm.get('dg').get('listeBav') as UntypedFormArray;
  }

  public get formulaire(): UntypedFormGroup {
    return this.rootForm.get('moyens') as UntypedFormGroup;
  }

  public setStep(index: number): void {
    this.step = index;
  }

  private calculAutoTotauxA4c(index: number, tabBoucle: number[], varBoucle: string, totBoucle: string): void {
    this.subTab.push(this.lieuxBav.controls[index].get(varBoucle).valueChanges.pipe(debounceTime(100)).subscribe(valeur2 => {
          tabBoucle.splice(index,1,valeur2);
          //console.log(tabBoucle);
          let sum = tabBoucle.reduce((a,b)=>a+b,0);
          //console.log(sum);
          this.formulaire.get(totBoucle).setValue(sum);
    }));
    this.lieuxBav.controls[index].get(varBoucle).updateValueAndValidity();         
    this.formulaire.get(totBoucle).updateValueAndValidity(); 
  }

}
